const stringToColour = str => {
  if (!str) return "#666";
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let colour = "#";
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff;
    colour += ("00" + value.toString(16)).substr(-2);
  }
  return colour;
};

const edgeColour = size => {
  if (size < 5) return "#bbb";
  if (size < 15) return "#14c9cb";
  if (size < 25) return "#1bd7bb";
  if (size < 50) return "#22e4ac";
  return "#2af598";
};

export { stringToColour, edgeColour };
